import React, {FC} from "react";
import {css} from "@emotion/css";
import {colorScales} from "@octopusdeploy/design-system-tokens";
import {EnvironmentName} from "client/resources/environmentName";
import { AppInfoResource } from "~/client/resources/appInfoResource";


const bannerStyle = css`
    color: ${colorScales.white};
    font-size: 0.8125rem;
    height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    a, a:hover {
        color: ${colorScales.white};
    }
`;

const productionStyle = css`
    ${bannerStyle};
    background-color: ${colorScales.purple["600"]};
`;

const testStyle = css`
    ${bannerStyle};
    background-color: ${colorScales.orange["400"]};
`;

const developmentStyle = css`
    ${bannerStyle};
    background-color: ${colorScales.green["400"]};
`;

function getEnvironmentStyle(name: EnvironmentName): string {
    switch (name) {
        case EnvironmentName.Production:
            return productionStyle;
        case EnvironmentName.Preprod:
        case EnvironmentName.Test:
            return testStyle;
        case EnvironmentName.Development:
            return developmentStyle;
    }
}

interface EnvironmentProps {
    appInfo?: AppInfoResource;
}

const EnvironmentBanner: FC<EnvironmentProps> = ({appInfo}) => {
    if (!appInfo) {
        return <span>...</span>;
    }

    return <div className={getEnvironmentStyle(appInfo.Environment)}>
        {appInfo.Environment} {
            appInfo.Environment?.toLowerCase() === appInfo.PortalInstance?.toLowerCase() ? "" : <>
                - {appInfo.PortalInstance}
            </>
        }
    </div>;
};

export default EnvironmentBanner;